import appConfig from 'src/config/app.config.json'
import zipEligibilityConfig from 'src/config/zipEligibility.json'
import { getAppConfig } from './getAppConfig'

try {
  const allConfig = getAppConfig()
  const hostnameParts = window.location.hostname.split('.')
  const siteName = hostnameParts[0].toLowerCase().trim()

  const dnsConfig = appConfig.find(x => {
    const hName = x.hostname.split('.')
    return siteName === hName[0].toString().toLowerCase().trim()
  })

  const listName = dnsConfig?.ELIGIBILITY_LIST_NAME ?? 'undefined'
  const eligibilityInformation =
    (
      zipEligibilityConfig as Record<
        string,
        { 'Zip Code': string; State: string; County: string }[]
      >
    )[listName] ?? []
  const eligibilityZipCodes = eligibilityInformation.map(e => e['Zip Code'])

  window.APP_CONFIG = (
    appConfig !== null && allConfig !== null && dnsConfig !== null
      ? {
          ...allConfig,
          ...dnsConfig,
          ELIGIBILITY_ZIP_CODES: eligibilityZipCodes,
        }
      : {}
  ) as typeof window.APP_CONFIG
} catch (e) {
  console.error(e)
  window.APP_CONFIG = {} as typeof window.APP_CONFIG
  // swallow
  console.info('INVALID SITE CONFIG')
} finally {
  if (window.APP_CONFIG == null) {
    window.APP_CONFIG = {} as typeof window.APP_CONFIG
  }
}
